var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('info-block',{attrs:{"value-color":"red","data":_vm.order,"fields":_vm.fields,"title":_vm.order && _vm.order.id ? (_vm.order.type === 'prescription' ? '订单信息' : '采购信息') : ''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }